import { render, staticRenderFns } from "./CommunicateDetails.vue?vue&type=template&id=03d1bdd7&scoped=true&"
import script from "./CommunicateDetails.vue?vue&type=script&lang=js&"
export * from "./CommunicateDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommunicateDetails.vue?vue&type=style&index=0&id=03d1bdd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1bdd7",
  null
  
)

export default component.exports